



























































































































































































	import { Component, Vue } from "vue-property-decorator";
	import { mapState } from "vuex";
	import {
		RedCapital,
		SelectedCountry,
		TitleTemplateDashboard,
	} from "@/configuration";
	import ProjectStatus from "@/components/dashboard/ProjectStatus.vue";
	import DatatableFilterPlugin from "@/filters";
	// @ts-ignore
	import JsonExcel from "vue-json-excel";
	import API from "@/api";
	import TableResponsive from "@/components/table/TableResponsive.vue";
	// @ts-ignore
	import { Tabs, TabItem } from 'vue-material-tabs';
	import ShowLoading from "@/components/panel/ShowLoading.vue";
	import moment from "moment";

	Vue.component("downloadExcel", JsonExcel);
	Vue.use(DatatableFilterPlugin);

	@Component({
		metaInfo: {
			title: "Cartola Anual",
			titleTemplate: TitleTemplateDashboard,
			htmlAttrs: {
				// @ts-ignore
				lang: RedCapital[SelectedCountry].Lang,
			},
		},
		computed: {
			...mapState(["user","setOpenMenuPanel"]),
			setOpenMenuPanel(){
				return this.$store.state.openMenuPanel;
			},
			filtered2() {
				return this.$data.dataCartola.filter((cartola: any) => {
					/* Formateando Data */
					let propsObjTableAll = {
						style: `text-align: center;
								font-size: 0.7rem;
								font-weight: 500;
								color: #8b8b8b`
					}
					let propsObjTableEstado = {
						style: `display: flex;
								justify-content: center;`
					}
					let propsObjTableButtons = {
						style: `display: flex;
								justify-content: center;`
					}
					// @ts-ignore
					cartola.datosEnTabla;
					let objTable = {
						id:{
							// @ts-ignore
							value: cartola.id_proyecto,
							label: 'ID',
							props: propsObjTableAll
						},
						proyecto:{
							value: cartola.nombre_proyecto,
							label: 'ID',
							props: propsObjTableAll
						},
						inversion:{
							// @ts-ignore
							value: this.$options.filters.currency(cartola.inversion),
							label: 'Inversion',
							props: propsObjTableAll
						},
						fechaInversion:{
							// @ts-ignore
							value: moment(cartola.fecha_inversion).format("DD-MM-YYYY"),
							label: 'Fecha inversion',
							props: propsObjTableAll
						},
						saldoCapitalInicio:{
							// @ts-ignore
							value: this.$options.filters.currency(cartola.saldo_capital_inicial),
							label: 'Saldo Capital Inicio Período',
							props: propsObjTableAll
						},
						saldoCapitalFinal:{
							// @ts-ignore
							value: this.$options.filters.currency(cartola.saldo_capital_final),
							label: 'Saldo Capital Final Período',
							props: propsObjTableAll
						},
						pagosMes:{
							// @ts-ignore
							value: this.$options.filters.currency(parseInt(cartola.pagos)),
							label: 'Pagos Recibidos',
							props: propsObjTableAll
						},
						capitalPagado:{
							// @ts-ignore
							value: this.$options.filters.currency(parseInt(cartola.capital_pagado)),
							label: 'Capital Pagado',
							props: propsObjTableAll
						},
						interesPagado:{
							// @ts-ignore
							value: this.$options.filters.currency(parseInt(cartola.interes_pagado)),
							label: 'Interes Pagado',
							props: propsObjTableAll
						},
						interesDevengado:{
							// @ts-ignore
							value: this.$options.filters.currency(parseInt(cartola.interes_devengado)),
							label: 'Interes Pagado',
							props: propsObjTableAll
						},
						estado: {
							value: '',
							label: 'Estado',
							props: propsObjTableEstado,
							component: {
								name: 'ProjectStatus',
								props: {
									'project-status' : cartola.estado_real
								}
							}
						},
					}
					//@ts-ignore
					cartola.datosEnTabla = objTable
					return (
						//this.$data.name.includes(i.proyecto.nombre) ||
						this.$data.id.includes(cartola.id_proyecto)
					);
				});
			},
			filtered3() {
				return this.$data.dataCartolaAnual.filter((cartola: any) => {
					/* Formateando Data */
					let propsObjTableAll = {
						style: `text-align: center;
								font-size: 0.7rem;
								font-weight: 500;
								color: #8b8b8b`
					}
					let propsObjTableEstado = {
						style: `display: flex;
								justify-content: center;`
					}
					let propsObjTableButtons = {
						style: `display: flex;
								justify-content: center;`
					}
					// @ts-ignore
					cartola.datosEnTabla;
					let objTable = {
						id:{
							// @ts-ignore
							value: cartola.id_proyecto,
							label: 'ID',
							props: propsObjTableAll
						},
						proyecto:{
							value: cartola.nombre_proyecto,
							label: 'ID',
							props: propsObjTableAll
						},
						inversion:{
							// @ts-ignore
							value: this.$options.filters.currency(cartola.inversion),
							label: 'Inversion',
							props: propsObjTableAll
						},
						fechaInversion:{
							// @ts-ignore
							value: moment(cartola.fecha_inversion).format("DD-MM-YYYY"),
							label: 'Fecha inversion',
							props: propsObjTableAll
						},
						saldoCapitalInicio:{
							// @ts-ignore
							value: this.$options.filters.currency(cartola.saldo_capital_inicial),
							label: 'Saldo Capital Inicio Período',
							props: propsObjTableAll
						},
						saldoCapitalFinal:{
							// @ts-ignore
							value: this.$options.filters.currency(cartola.saldo_capital_final),
							label: 'Saldo Capital Final Período',
							props: propsObjTableAll
						},
						pagosMes:{
							// @ts-ignore
							value: this.$options.filters.currency(parseInt(cartola.pagos)),
							label: 'Pagos Recibidos',
							props: propsObjTableAll
						},
						capitalPagado:{
							// @ts-ignore
							value: this.$options.filters.currency(parseInt(cartola.capital_pagado)),
							label: 'Capital Pagado',
							props: propsObjTableAll
						},
						interesPagado:{
							// @ts-ignore
							value: this.$options.filters.currency(parseInt(cartola.interes_pagado)),
							label: 'Interes Pagado',
							props: propsObjTableAll
						},
						interesDevengado:{
							// @ts-ignore
							value: this.$options.filters.currency(parseInt(cartola.interes_devengado)),
							label: 'Interes Pagado',
							props: propsObjTableAll
						},
						estado: {
							value: '',
							label: 'Estado',
							props: propsObjTableEstado,
							component: {
								name: 'ProjectStatus',
								props: {
									'project-status' : cartola.estado_real
								}
							}
						},
					}
					//@ts-ignore
					cartola.datosEnTabla = objTable
					return (
						//this.$data.name.includes(i.proyecto.nombre) ||
						this.$data.id.includes(cartola.id_proyecto)
					);
				});
			},
		},
	data() {
		return {
			payments2: "",
			RedCapital,
			SelectedCountry,
			filters: {
				id: null,
				id2:null
			},
			tabs: null,
			anio:new Date().getFullYear() -1,
			changeFiltro:0,
			id: "",
			id2: "",
			name: "",
			state: "",
			canShow: false,
			showId: false,
			payments: null,
			newPayments: null,
			states: null,
			dialog: false,
			viewFees: false,
			tablaTab1: {
				headers: [
					{
						text: "ID proyecto",
						align: "center",
					},{
						text: "Proyecto",
						align: "center",
					},{
						text: "Inversion",
						align: "center",
					},{
						text: "Fecha Inversion",
						align: "center",
					},{
						text: "Saldo Capital Inicio Período",
						align: "center",
					},{
						text: "Saldo Capital Final Período",
						align: "center",
					},{
						text: "Pagos Recibidos",
						align: "center",
					},{
						text: "Capital Pagado",
						align: "center",
						sortable: false,
					},{
						text: "Interés Pagado",
						align: "center",
						sortable: false,
					},{
						text: "Interes Devengado",
						align: "center",
						sortable: false,
					},
					{
						text: "Estado",
						align: "center",
						sortable: false,
					}
				],
				msjEmpty: 'No existen registros en tu cuenta',
				rowsPerPage: {
					txt: 'Registro por página',
					itm: [10, 25, 50, { text: 'Todos', value: -1 }]
				},
			},
			tablaTab2: {
				headers: [
					{
						text: "ID proyecto",
						align: "center",
					},{
						text: "Proyecto",
						align: "center",
					},{
						text: "Inversion",
						align: "center",
					},{
						text: "Fecha Inversion",
						align: "center",
					},{
						text: "Saldo Capital Inicio Período",
						align: "center",
					},{
						text: "Saldo Capital Final Período",
						align: "center",
					},{
						text: "Pagos Recibidos",
						align: "center",
					},{
						text: "Capital Pagado",
						align: "center",
						sortable: false,
					},{
						text: "Interés Pagado",
						align: "center",
						sortable: false,
					},{
						text: "Interes Devengado",
						align: "center",
						sortable: false,
					},
					{
						text: "Estado",
						align: "center",
						sortable: false,
					}
				],
				msjEmpty: 'No existen registros en tu cuenta',
				rowsPerPage: {
					txt: 'Registro por página',
					itm: [10, 25, 50, { text: 'Todos', value: -1 }]
				},
			},
			dataCartola: null,
			dataCartolaExcel: null,
			dataCartolaAnual: null,
			dataCartolaExcelAnual: null,
			
		};
	},
	async beforeMount() {
		API.getCartolaInversion()
			.then((cartolaInversion: any) => {
				this.$data.dataCartola = cartolaInversion.data;
				this.$data.filters.id = this.$data.dataCartola
				.map((cartola: any) => cartola.id_proyecto)
				.filter((val: any) => val !== null);
			})
			.catch((error)=>{
				console.log(error);
			})
			// @ts-ignore
			.finally((x: any) => {
				API.getCartolaInversion()
				.then((cartolaInversionExcel: any) => {
					this.$data.dataCartolaExcel = cartolaInversionExcel.data;
				})
				.catch((error)=>{
					console.log(error);
				})
				// @ts-ignore
				.finally((x: any) => {})
			})


			API.getCartolaInversionAnual()
			.then((dataCartolaAnual: any) => {
				this.$data.dataCartolaAnual = dataCartolaAnual.data.sort((a:any, b:any)=> {
					return b.id_proyecto - a.id_proyecto
				});

				this.$data.filters.id2 = this.$data.dataCartolaAnual
				.map((cartola: any) => cartola.id_proyecto)
				.filter((val: any) => val !== null);
			})
			.catch((error)=>{
				console.log(error);
			})
			// @ts-ignore
			.finally((x: any) => {
				API.getCartolaInversionAnual()
				.then((cartolaInversionExcel: any) => {
					this.$data.dataCartolaExcelAnual = cartolaInversionExcel.data.sort((a:any, b:any)=> {
					return b.id_proyecto - a.id_proyecto
				});;
				})
				.catch((error)=>{
					console.log(error);
				})
				// @ts-ignore
				.finally((x: any) => {})
			})

			
		
		
		
		setTimeout(() => {
			this.$data.canShow = true;
		}, 1000);
		


	},
	watch: {
		changeFiltro(v){
			if (v == "0") {
				this.$data.cambioFiltro = false;
			} else {
				this.$data.cambioFiltro = true;
			}
		},
	},
	methods: {
		actualizarData(){
			// @ts-ignore
			this.resetFilters();
			API.getCartolaInversion()
			.then((cartolaInversion: any) => {
				this.$data.dataCartola = cartolaInversion;
				this.$data.filters.id = this.$data.dataCartola
				.map((cartola: any) => cartola.id_proyecto)
				.filter((val: any) => val !== null);
			})
			.catch((error)=>{
				console.log(error);
			})
			// @ts-ignore
			.finally((x: any) => {
				API.getCartolaInversion()
				.then((cartolaInversionExcel: any) => {
					this.$data.dataCartolaExcel = cartolaInversionExcel;
				})
				.catch((error)=>{
					console.log(error);
				})
				// @ts-ignore
				.finally((x: any) => {})
			})
		},
		actualizarDataAnual(){
			// @ts-ignore
			this.resetFilters();
			API.getCartolaInversionAnual()
			.then((dataCartolaAnual: any) => {
				this.$data.dataCartolaAnual = dataCartolaAnual.data.sort((a:any, b:any)=> {
					return b.id_proyecto - a.id_proyecto
				});

				this.$data.filters.id2 = this.$data.dataCartolaAnual
				.map((cartola: any) => cartola.id_proyecto)
				.filter((val: any) => val !== null);
			})
			.catch((error)=>{
				console.log(error);
			})
			// @ts-ignore
			.finally((x: any) => {
				API.getCartolaInversionAnual()
				.then((cartolaInversionExcel: any) => {
					this.$data.dataCartolaExcelAnual = cartolaInversionExcel.data.sort((a:any, b:any)=> {
					return b.id_proyecto - a.id_proyecto
				});;
				})
				.catch((error)=>{
					console.log(error);
				})
				// @ts-ignore
				.finally((x: any) => {})
			})

		},
		resetFilters() {
			this.$data.id = "";
		},
		resetFilters2() {
			this.$data.id = "";
		},
		
	},
	components: {
		ProjectStatus,
		TableResponsive,
		Tabs,
		TabItem,
		ShowLoading
	},
})
export default class CartolaMensual extends Vue {}
